import * as ko from "knockout";
import Bao from "./../services/bao-service";
import ConfigurationItemViewModel from "./configuration-item";
import BaoDialogViewModel from "./../factories/bao-dialog";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
function ContractViewModel(tabPage) {
    var self = this;
    ConfigurationItemViewModel.call(this, tabPage);
    self.StartDate = ko.observable();
    self.StartDateJs = ko.observable();
    self.ProvProz = ko.observable();
    self.Duration = ko.observable();
    self.ExtensionPeriod = ko.observable();
    self.NoticePeriod = ko.observable();
    self.BillingMonth = ko.observable();
    self.NextEndHtml = ko.observable();
    self.TerminationToHtml = ko.observable();
    self.SelectedContractTerminationCondition = ko.observable();
    self.SelectedContractTerminationCondition.subscribe(function (newValue) {
        self.ContractTerminationConditionKey(newValue.Key);
        self.CalculateContractFields();
    });
    self.CalculateContractFields = function () {
        if (self.Initialized() == true && tabPage.IsLoading() == false) {
            tabPage.IsLoading(true);
            Bao.post("ConfigurationItem/ContractModelRefresh", JSON.stringify({
                model: self.MinimizeEntity()
            }), function (result) {
                self.NextEndHtml(result.NextEndHtml);
                self.TerminationToHtml(result.TerminationToHtml);
                tabPage.IsLoading(false);
            });
        }
    };
    self.StartDateJs.subscribe(self.CalculateContractFields);
    self.Duration.subscribe(self.CalculateContractFields);
    self.ExtensionPeriod.subscribe(self.CalculateContractFields);
    self.NoticePeriod.subscribe(self.CalculateContractFields);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.ConfigurationItemTypeId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(self.Name1())) {
            isComplete = false;
        }
        if (self.ConfigurationItemStatusId() == null) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.ResetAccountAssignment = function (row) {
        self.AccountAssignment(null);
    };
}
;
Bao.inherit(ContractViewModel, ConfigurationItemViewModel);
ContractViewModel.prototype.DeleteMessageKey = "msgDeleteContract";
ContractViewModel.prototype.RefreshUrl = "ConfigurationItem/GetContract";
ContractViewModel.prototype.SaveUrl = "ConfigurationItem/SaveContract";
ContractViewModel.prototype.DeleteUrl = "ConfigurationItem/DeleteContract";
ContractViewModel.prototype.PermissionForward = "ContractMoveForwardSearch";
ContractViewModel.prototype.PermissionBackward = "ContractMoveBackwardSearch";
ContractViewModel.prototype.PermissionRefresh = "ContractRefresh";
ContractViewModel.prototype.PermissionSave = "ContractSave";
ContractViewModel.prototype.PermissionDelete = "ContractDelete";
ContractViewModel.prototype.ConfigurationItemTypeKeyCategory = "Contract";
ContractViewModel.prototype.PermissionAuditTrail = "ContractAudit";
export default ContractViewModel;